module.exports = __webpack_public_path__ + "assets/img/wx_qrcode.f3d8109a.jpg";